export enum FinanceOutTransactionType {
  TIME = "TIME",
  SUM = "SUM"
}